import React, { FC } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';
import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import { scale } from '@components/frame';
import Button from '@styles/buttons';
import Svg from '@styles/icons/svg';
import { Feedback, isWeb } from '@helpers';
import type { RootErrorFallbackProps } from './types';

const RootErrorFallback: FC<RootErrorFallbackProps> = ({ C, sessionId }) => {
  const handleReload = () => {
    if (isWeb && typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  const handleReportProblem = () => {
    Feedback({ type: 'error' });
  };

  return (
    <View style={[styles.container, { backgroundColor: C('Background/Light/System [web]') }]} testID={"error-boundary-root-fallback"}>
      <View style={[styles.card, { backgroundColor: C('Background/Light/Secondary') }]}>
        <View style={styles.iconContainer}>
          <Svg icon="errorBig" width={scale(80)} height={scale(80)} color="Label/Light/Error" />
        </View>

        <Text style={[font['Title 1'], styles.title, { color: C('Label/Light/Error') }]}>
          {i18n.t('App Error')}
        </Text>

        <Text style={[font['Body Large'], styles.subtitle, { color: C('Label/Light/Secondary') }]}>
          {i18n.t('The application encountered a critical error')}
        </Text>

        <View style={styles.buttonRow}>
          <Button variant="L" type="Primary" onPress={handleReload} testID={"error-boundary-root-reload"}>
            {i18n.t('Reload App')}
          </Button>
        </View>

        <Button variant="L" type="Only Text Link" onPress={handleReportProblem}>
          {i18n.t('Report to Smart Factory')}
        </Button>

        {sessionId && (
          <Text selectable testID={"error-boundary-session-id"} style={[font.Footnote, styles.sessionId, { color: C('Label/Light/Tertiary') }]}>
            {i18n.t('Session ID')}: {sessionId}
          </Text>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: scale(32),
  },
  card: {
    padding: scale(48),
    borderRadius: scale(16),
    maxWidth: scale(560),
    width: '100%',
    alignItems: 'center',
  },
  iconContainer: {
    marginBottom: scale(24),
  },
  title: {
    marginBottom: scale(12),
    textAlign: 'center',
  },
  subtitle: {
    marginBottom: scale(32),
    textAlign: 'center',
  },
  buttonRow: {
    marginBottom: scale(16),
  },
  sessionId: {
    marginTop: scale(16),
    textAlign: 'center',
  },
});

export default ColorWrapper(RootErrorFallback);
